export default __webpack_public_path__ + "static/media/externalLoads.29edfc64.png";